var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" Page Not Found ")]),_c('h5',[_vm._v(" Redirecting you to Home Page in "+_vm._s(_vm.remainingTime)+" secs")])])}
var staticRenderFns = []

export { render, staticRenderFns }